import { Injectable } from '@angular/core';
import {BaseService} from '@core/service/base.service';
import {UrlConstant} from '@shared/constants/url.constant';
import {EditUserRequest, FilterUserRequest} from '@modules/administration/users/interfaces/user.request';
import {FilterOrderRequest} from "@modules/administration/orders/interfaces/order.request";
import {OrderModel} from "@modules/administration/orders/interfaces/order.model";

@Injectable()
export class OrderService extends BaseService{
  readonly prefixUrl =  UrlConstant.ORDER.PREFIX;
  public getList(filter: FilterOrderRequest) {
    return this.post(this.prefixUrl + UrlConstant.ORDER.LIST, filter);
  }

  public add(data: OrderModel) {
    return this.post(this.prefixUrl + UrlConstant.ORDER.ADD, data);
  }

  public edit(data: OrderModel) {
    return this.post(this.prefixUrl + UrlConstant.ORDER.EDIT, data);
  }

  public deleteOrder(data: OrderModel) {
    return this.post(this.prefixUrl + UrlConstant.ORDER.DELETE, data);
  }

  public updateShipped(id: number) {
    return this.post(this.prefixUrl + UrlConstant.ORDER.UPDATE_SHIPPED, { id });
  }

  public updatePrint(id: number) {
    return this.post(this.prefixUrl + UrlConstant.ORDER.UPDATE_PRINT, { id });
  }
}
